import React, { Component } from 'react';
import './App.css';

import BetaLandingPage from './components/BetaLandingPage/betaLandingPage';

import AppHeader from './components/AppHeader/appheader';
import Sidebar from './components/Sidebar/sidebar';
import ContentArea from './components/ContentArea/contentarea';

import { generateCode } from './components/SnippetGenerator/snippetGenerator';

import { VelocityComponent } from 'velocity-react';
import 'velocity-animate';
import 'velocity-animate/velocity.ui';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faQuestionCircle, faDesktop, faMobileAlt, faTabletAlt } from '@fortawesome/free-solid-svg-icons';

import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import { olapicSSOClient } from 'olapic-sso-client';
import Intercom, { IntercomAPI } from 'react-intercom';
import FullStory, { FullStoryAPI } from 'react-fullstory';

library.add(faQuestionCircle, faDesktop, faMobileAlt, faTabletAlt);

class App extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    const { cookies } = props;

    // set the url for the SSO server
    olapicSSOClient.setClientConfig({
      api: {
        url: 'https://sso.photorank.me',
      },
    });

    // sets the configuration for the sso client. In order to get the account id/name, the api_key, and the user id/name from the
    // authnz server, I'm using the content_engine scope
    olapicSSOClient.setConfig({
      accountPermissionScopes: ['content_engine'],
      accountScope: 'content_engine',
      accountSelection: true,
      client: 'admin',
      callback: 'https://imageapi.photorank.me/',
    });

    this.state = {
      baseAPIv2Host: 'https://photorankapi-a.akamaihd.net',
      baseDISHost: 'https://kd9sq2whx8.execute-api.us-east-1.amazonaws.com/pbox',
      authToken: '',
      customerId: '',
      customerName: '',
      userId: '',
      userEmail: '',
      userName: '',
      filterType: 'media_library',
      filterValue: '',
      sortingOption: 'recent',
      fallbackImage: '',
      imageSize: 'normal',
      numberOfImages: 4,
      paddingSize: 10,
      imagesPerRowInMobile: 2,
      cropping: false,
      cropSize: {
        width: 300,
        height: 300,
      },
      cropFit: 'cover',
      cropPosition: 'center',
      cropBackground: 'blur',
      cropBackgroundHex: '#000',
      htmlOutput: '',
      optIn: cookies.get('olapicEmailBetaOptin') || false,
      isInIframe: this.isInIframe(),
      isSessionAvailable: false,
    };

    // eager load some data so user doesn't have to wait for APIv2 response to resolve when they generate code
    this.eagerLoadApiV2();
  }

  setAuthToken = e => {
    this.setState({
      authToken: e.target.value,
    });
  };

  setFilterType = e => {
    this.setState({
      filterType: e.target.value,
    });
  };

  setFilterValue = e => {
    this.setState({
      filterValue: e.target.value,
    });
  };

  setSortingOption = e => {
    this.setState({
      sortingOption: e.target.value,
    });
  };

  setImageResolution = e => {
    this.setState({
      imageSize: e.target.value,
    });
  };

  setCropping = e => {
    this.setState({
      cropping: e.target.checked,
    });
  };

  setCropWidth = e => {
    this.setState({
      cropSize: {
        ...this.state.cropSize,
        width: e.target.value,
      },
    });
  };

  setCropHeight = e => {
    this.setState({
      cropSize: {
        ...this.state.cropSize,
        height: e.target.value,
      },
    });
  };

  setCropFit = e => {
    this.setState({
      cropFit: e.target.value,
    });
  };

  setCropPosition = e => {
    this.setState({
      cropPosition: e.target.value,
    });
  };

  setCropBackground = e => {
    this.setState({
      cropBackground: e.target.value,
    });
  };

  setCropBackgroundHex = hexValue => {
    this.setState({
      cropBackgroundHex: hexValue,
    });
  };

  setNumberOfImages = value => {
    this.setState({
      numberOfImages: parseInt(value, 10),
    });
  };

  setPaddingSize = value => {
    this.setState({
      paddingSize: parseInt(value, 10) || 0,
    });
  };

  setImagesPerRowInMobile = value => {
    this.setState({
      imagesPerRowInMobile: parseInt(value, 10) || 0,
    });
  };

  setFallbackImage = e => {
    this.setState({
      fallbackImage: e.target.value,
    });
  };

  setSnippet = async e => {
    e.preventDefault();

    if (this.state.authToken === '') {
      alert('Please make sure that the API key is valid.');
      return;
    }

    let customerUrl = `${this.state.baseAPIv2Host}/?auth_token=${this.state.authToken}`;
    let customerObject = await fetch(customerUrl).then(res => res.json());
    let customerId = customerObject.data._embedded.customer.id;

    IntercomAPI('trackEvent', 'Email Studio - Code Generated');

    this.setState({
      customerId,
      htmlOutput: generateCode.bind(this)(),
    });
  };

  setOptIn() {
    const { cookies } = this.props;

    cookies.set('olapicEmailBetaOptin', 'true', { path: '/' });
    IntercomAPI('trackEvent', 'Email Studio - Beta Agreement Acceptance');

    this.setState({
      optIn: true,
    });
  }

  fullStoryIdentify() {
    // we may not have the session information constantly, so we need to check if the session is available
    if (this.state.isSessionAvailable) {
      FullStoryAPI('identify', this.state.userEmail, {
        email: this.state.userEmail,
        displayName: this.state.userName,
        brand_str: this.state.customerName,
        brandId_str: this.state.customeId,
      });
    }
  }

  // This function allows the app to eager load APIv2 to warm up the cache on CDN. This is to avoid additional latency when user generates the code and previews the images
  async eagerLoadApiV2() {
    // check if session is available
    if (this.state.isSessionAvailable === true) {
      let customerUrl = `${this.state.baseAPIv2Host}/?auth_token=${this.state.authToken}&version=v2.2`;
      let customerObject = await fetch(customerUrl).then(res => res.json());

      let customerMediaRecentUrl = `${this.state.baseAPIv2Host}/customers/${
        customerObject.data._embedded.customer.id
      }/media/recent?auth_token=${this.state.authToken}`;
      let customerMediaRecent = await fetch(customerMediaRecentUrl).then(res => res.json());
    }
  }

  /**
   * Loads session data if SSO client is authenticated
   */
  loadSessionData() {
    if (olapicSSOClient.isAuthenticated()) {
      const session = olapicSSOClient.getSession();
      this.setState(() => ({
        authToken: session.account.settings.api_key,
        customerId: session.account.id,
        customerName: session.account.name,
        userId: session.user.id,
        userEmail: session.user.email,
        userName: session.user.name,
        isSessionAvailable: true,
      }));
    }
  }

  // Checks if the app is loaded inside iframe or not
  isInIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  componentDidMount() {
    this.fullStoryIdentify(); // if the user is logged in upon the first render, then we need to identify the user

    // check if SSO client is authenticated
    if (olapicSSOClient.isAuthenticated()) {
      // if authenticated, check if the account session is outdated
      if (olapicSSOClient.isTheAccountOutdated()) {
        olapicSSOClient
          .refreshSession() // refresh the session
          .then(() => {
            window.location.href = '/'; // refresh the frame
          })
          .catch(error => alert(error));
      }

      // bind the loadSessionData function to the session change event
      olapicSSOClient.on(olapicSSOClient.EVENTS.session.change, this.loadSessionData.bind(this));
      this.loadSessionData(); // load session data for first time
    } else {
      // if not authenticated, then trigger authentication
      olapicSSOClient
        .authenticate()
        .then(() => {
          setTimeout(() => {
            window.location.href = '/';
          }, 0);
        })
        .catch(error => {
          alert(error);
        });
    }
  }

  // if the user is not logged in upon the first render, then the component will update,
  // upon update, we should have the user information
  componentDidUpdate() {
    this.fullStoryIdentify();
  }

  render() {
    // checks if the user is authenticated.
    // if not, it will redirect the client and ensure that no content flashes before the redirect occurs
    if (!this.state.isSessionAvailable) {
      return null;
    }

    return (
      <div className={`App ${this.state.isInIframe ? 'iframe' : ''}`}>
        <Intercom
          appID="mpj8a0bm"
          name={this.state.userName}
          email={this.state.userEmail}
          company={{ id: this.state.customerId, name: this.state.customerName }}
        />
        <FullStory org="photorank.me" host="fullstory.com" namespace="FS" debug="false" />
        {this.state.optIn ? (
          <React.Fragment>
            {!this.state.isInIframe && <AppHeader />}

            <section className="App-main clearfix">
              <VelocityComponent animation="transition.fadeIn" duration={2500} runOnMount={true}>
                <Sidebar
                  actions={{
                    setAuthToken: e => this.setAuthToken(e),
                    setFilterType: e => this.setFilterType(e),
                    setFilterValue: e => this.setFilterValue(e),
                    setSortingOption: e => this.setSortingOption(e),
                    setImageResolution: e => this.setImageResolution(e),
                    setNumberOfImages: e => this.setNumberOfImages(e),
                    setPaddingSize: e => this.setPaddingSize(e),
                    setImagesPerRowInMobile: e => this.setImagesPerRowInMobile(e),
                    setFallbackImage: e => this.setFallbackImage(e),
                    setCropping: e => this.setCropping(e),
                    setCropWidth: e => this.setCropWidth(e),
                    setCropHeight: e => this.setCropHeight(e),
                    setCropFit: e => this.setCropFit(e),
                    setCropPosition: e => this.setCropPosition(e),
                    setCropBackground: e => this.setCropBackground(e),
                    setCropBackgroundHex: hexValue => this.setCropBackgroundHex(hexValue),
                    setSnippet: e => this.setSnippet(e),
                  }}
                  {...this.state}
                />
              </VelocityComponent>
              <VelocityComponent animation="transition.fadeIn" duration={2500} runOnMount={true}>
                <ContentArea htmlOutput={this.state.htmlOutput} />
              </VelocityComponent>
            </section>
          </React.Fragment>
        ) : (
          <BetaLandingPage setOptIn={e => this.setOptIn(e)} />
        )}
      </div>
    );
  }
}

export default withCookies(App);



// WEBPACK FOOTER //
// ./src/App.js